<template>
  <div class="restaurantBookSet">
    <div class="title">
      <div>{{$route.meta.title}}</div>
    </div>
    <wholeVue/>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { getapi, postapi } from '../../store/fetch'
import wholeVue from './whole.vue'
export default {
  name: 'restaurantBookSet',
  components: {
    wholeVue
  },
  computed: {
    ...mapState({
      restaurants: 'restaurants',
      defaultStore: 'defaultStore'
    }),
    page () {
      return this.$route.query.page
    }
  },
  data () {
    return {
      restaurant: null,
      restaurantInfo: null
    }
  },
  async mounted () {
    this.restaurant = this.defaultStore || this.restaurants[0]
  },
  methods: {
    async update (ev) {
      if (this.restaurant) {
        const r = await postapi(`restaurantSetting/${this.restaurant}`, ev)
        this.restaurantInfo = r
      }
    }
  },
  watch: {
    restaurant: {
      async handler () {
        if (this.restaurant) {
          this.restaurantInfo = await getapi(`restaurantSetting/${this.restaurant}`)
        }
      },
      immediate: true
    }
  }
}
</script>

<style lang="scss" scoped>
.restaurantBookSet {
  display: grid;
  grid-template-columns: 100%;
  grid-template-rows: 89px 1fr;
  height: 100%;
}
.title > input[type=radio] {
  width: 120px;
  height: 40px;
  appearance: none;
  background-color: var(--color-border);
  color: #FFFFFF;
  border-radius: 3px;
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 500;
  font-size: 18px;
  letter-spacing: 0.1em;
  display: flex;
  align-items: center;
  justify-content: center;
  &::before {
    content: attr(value);  }

  &:checked {
    background-color: var(--color-pri);
  }

}
.title {
  margin-inline: 20px;
  background-color: #FFF;
  height: 70px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 20px;
  &::before {
    content: '';
    display: inline-flex;
    width: 55px;
    height: 55px;
    mask-image: url(./setting.svg);
    mask-repeat: no-repeat;
    mask-position: center;
    background-color: var(--color-pri);
  }
  height: 89px;
  display: flex;
  align-items: center;
  font-family: Noto Sans TC;
  font-style: normal;
  font-weight: normal;
  font-size: 32px;
  letter-spacing: 0.15em;
  border-bottom: 1px solid var(--color-border);
  color: var(--color-pri);
  gap: 10px;
}
</style>
